import { PageEvent } from '@angular/material/paginator';
import { Chip } from '@models/chip';

/**
 * class of constant variables, which are used in various components
 */
export class Constants {
    /** localization texts */
    public static loadingText = $localize`:@@table-data-loading:Loading...`;
    public static noDataText = $localize`:@@table-data-nodata:No data available`;

    /** CRUD column header */
    public static actionColumn = $localize`:@@table-header-action:Action`;

    /**
     * list of currently supported website languages
     * only de and en are supported as Angular locale bundles
     * @returns [] array of language codes
     */
    public static supportedLanguages: string[] = [ 'de-DE', 'en-US' ];

    /**
     * list of currently supported locales
     * used to format dates, numbers and currency
     * @returns [] array of supported format locales
     */
    public static supportedLocales: string[] = [
        'de-DE',
        'de-AT',
        'de-CH',
        'en-US',
        'en-GB',
        'es-MX',
        'fr-FR',
        'nl-NL',
        'zh-Hans'
    ];

    /**
     * list of supported Scope client languages
     * used to set the language when launching the Scope client
     * no regional duplicates — one entry per language
     * @returns [] array of scope language codes
     */
    public static scopeLanguages: string[] = [
        'de-DE',
        'en-US',
        'es-MX',
        'fr-FR',
        'nl-NL',
        'zh-Hans'
    ];

    public static roles = {
        RSI_Super_Administrator: "RSI_Super_Administrator",
        Scope_Administrator: "Scope_Administrator",
        Scope_User: "Scope_User"
    };

    /**
     * defines ranges of items per page in dataTable paginator
     */
    public static pageSizeOptions: number[] = [ 5, 10, 25, 50, 100 ];

    /**
     * default dataTable settings
     *
     * - length: default length of data
     * - pageIndex: default page index
     * - pageSize: default number of items shown on one page
     * @returns object with settings
     */
    public static pageSettings(): PageEvent {
        return {
            length: 0,
            pageIndex: 0,
            pageSize: 10
        };
    }

    public static businessFields: Chip[] = [
        { id: 'airfreight', icon: 'flight', text: $localize`:@@button-label-airfreight:Air` },
        { id: 'seafreight', icon: 'directions_boat', text: $localize`:@@button-label-seafreight:Ocean` },
        { id: 'landfreight', icon: 'local_shipping', text: $localize`:@@button-label-landfreight:Road` },
        { id: 'export', icon: 'logout', text: $localize`:@@button-label-export:Export` },
        { id: 'import', icon: 'login', text: $localize`:@@button-label-import:Import` },
    ];

    public static services: Chip[] = [
        { id: 'export-agent', icon: '', text: $localize`:@@button-label-export-agent:Export agent` },
        { id: 'import-agent', icon: '', text: $localize`:@@button-label-import-agent:Import agent` },
        { id: 'trucker', icon: '', text: $localize`:@@button-label-trucker:Trucker` },
        { id: 'express', icon: '', text: $localize`:@@button-label-express:Express` },
        { id: 'clearance', icon: '', text: $localize`:@@button-label-clearance:Import customs clearance` },
        { id: 'declaration', icon: '', text: $localize`:@@button-label-declaration:Export declarations` },
        { id: 'exit', icon: '', text: $localize`:@@button-label-exit:EXIT - Customs clearance` },
        { id: 'shipping', icon: '', text: $localize`:@@button-label-shipping:Shipping` },
        { id: 'warehousing', icon: '', text: $localize`:@@button-label-warehousing:Customs warehouse` },
        { id: 'processing', icon: '', text: $localize`:@@button-label-processing:Inward processing` },
    ];

    public static sortbyname = [
        { id: 'asc', text: $localize`:@@select-option-sortbyname-asc:Name A-Z` },
        { id: 'desc', text: $localize`:@@select-option-sortbyname-desc:Name Z-A` }
    ];

    public static companySizes = [
        { id: '0-10' },
        { id: '10-49' },
        { id: '50-250' },
        { id: '250+' }
    ];

    public static readonly phonePattern = '^[+]?[(]?[0-9]{1,5}[)]?[-s. /0-9]*$';
    public static readonly emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    public static readonly urlPattern = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,6}(\/[^\s]*)?$/;
}
